module.exports = __webpack_public_path__ + "static/media/younaga3-shape.7e13f530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/younaga3-shape.png
// module id = 1327
// module chunks = 1